import React from 'react';
import { Col, Row } from 'react-bootstrap';
import CustomWidget from '../Custom/CustomWidget';
import DemandVsTime from '../EnergyEfficiencyApp/EEReports/DemandVsTime';
import Demand from './Charts/Demand';
import DemandOverTime from './Charts/DemandOverTime';
import PeakDemandTable from './Charts/PeakDemandTable';

// eslint-disable-next-line no-unused-vars
const TabDemand = ({ hirarchy }) => {
  const props = {
    type: hirarchy.type.label,
    id: hirarchy.level.value,
    units: hirarchy.units,
  };
  return (
    <>
      <Row>
        <CustomWidget
          size={12}
          id={'chrtPeakDemandProfile'}
          title={'Peak Demand Profile'}
        >
          <Demand {...props} />
        </CustomWidget>
      </Row>
      <Row>
        <Col lg={12}>
          <CustomWidget
            size={8}
            id={'chrtdemandOverTime'}
            title={'Demand Over Time'}
          >
            <DemandOverTime {...props} />
          </CustomWidget>
          <CustomWidget size={4} id={'chrtPeakDemandTable'}>
            <PeakDemandTable {...props} />
          </CustomWidget>

          {/* show only when type is selected as Asset */}
          {props.type === 'Asset' && <DemandVsTime id={props.id} />}
        </Col>
      </Row>
    </>
  );
};

export default TabDemand;
